import RedirectEngine from './RedirectEngine'

export default (context, inject) => {
  if (process.server) {
    inject('redirectEngine', RedirectEngine.getSingletonInstance())
  }
}
